import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_SUB_TASK, ADD_SUB_TASK_FAILED, ADD_SUB_TASK_SUCCESS, ADD_TASK, ADD_TASK_CATEGORY, ADD_TASK_CATEGORY_FAILED, ADD_TASK_CATEGORY_SUCCESS, ADD_TASK_FAILED, ADD_TASK_FILES, ADD_TASK_FILES_FAILED, ADD_TASK_FILES_SUCCESS, ADD_TASK_LABEL, ADD_TASK_LABEL_FAILED, ADD_TASK_LABEL_SUCCESS, ADD_TASK_STATUS, ADD_TASK_STATUS_FAILED, ADD_TASK_STATUS_SUCCESS, ADD_TASK_SUCCESS, DELETE_SUB_TASK, DELETE_SUB_TASK_FAILED, DELETE_SUB_TASK_SUCCESS, DELETE_TASK, DELETE_TASK_CATEGORY, DELETE_TASK_CATEGORY_FAILED, DELETE_TASK_CATEGORY_SUCCESS, DELETE_TASK_FAILED, DELETE_TASK_FILES, DELETE_TASK_FILES_FAILED, DELETE_TASK_FILES_SUCCESS, DELETE_TASK_LABEL, DELETE_TASK_LABEL_FAILED, DELETE_TASK_LABEL_SUCCESS, DELETE_TASK_STATUS, DELETE_TASK_STATUS_FAILED, DELETE_TASK_STATUS_SUCCESS, DELETE_TASK_SUCCESS, FILTERED_TASK, FILTERED_TASK_FAILED, FILTERED_TASK_SUCCESS, SUB_TASK, SUB_TASK_FAILED, SUB_TASK_SUCCESS, TASK, TASK_CATEGORY, TASK_CATEGORY_FAILED, TASK_CATEGORY_SUCCESS, TASK_FAILED, TASK_FILES, TASK_FILES_FAILED, TASK_FILES_SUCCESS, TASK_LABEL, TASK_LABEL_FAILED, TASK_LABEL_SUCCESS, TASK_STATUS, TASK_STATUS_FAILED, TASK_STATUS_SUCCESS, TASK_SUCCESS, UPDATE_SUB_TASK, UPDATE_SUB_TASK_FAILED, UPDATE_SUB_TASK_SUCCESS, UPDATE_TASK, UPDATE_TASK_FAILED, UPDATE_TASK_FILES, UPDATE_TASK_FILES_FAILED, UPDATE_TASK_FILES_SUCCESS, UPDATE_TASK_LABEL, UPDATE_TASK_LABEL_FAILED, UPDATE_TASK_LABEL_SUCCESS, UPDATE_TASK_STATUS, UPDATE_TASK_STATUS_FAILED, UPDATE_TASK_STATUS_SUCCESS, UPDATE_TASK_SUCCESS ,RUNNING_TASK, RUNNING_TASK_SUCCESS, RUNNING_TASK_FAILED} from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getTasks = () => async (dispatch) => {
  dispatch({
    type: TASK,
  });
  try {
    let response = await api(`task/taskList`, "get", {}, getAuthHeader());
    dispatch({
      type: TASK_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Task list error ====>", error);
    return dispatch({
      type: TASK_FAILED,
      payload: error?.message,
    });
  }
};

export const getFilteredTasks = (id) => async (dispatch) => {
  dispatch({
    type: FILTERED_TASK,
  });
  try {
    let response = await api(`task/filteredtasks/${id}`, "get", {}, getAuthHeader());
    dispatch({
      type: FILTERED_TASK_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching filtered task list error ====>", error);
    return dispatch({
      type: FILTERED_TASK_FAILED,
      payload: error?.message,
    });
  }
};

export const addTask = (data) => async dispatch => {
  dispatch({
    type: ADD_TASK
  })
  try {
    let response = await api(`task/add`, 'post', data, getAuthHeader())
    console.log('add task data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_TASK_SUCCESS,
      payload: response?.data?.task
    })
    return response
  } catch (error) {
    console.log("while Adding task error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_TASK_FAILED,
      payload: error?.message
    })
  }
}

export const updateTask = (id, data, showToast) => async dispatch => {
  dispatch({
    type: UPDATE_TASK
  })
  document.body.classList.add('glass-overlay');
  try {
    let response = await api(`task/update/${id}`, 'put', data, getAuthHeader())
    console.log('update task data', response);
    showToast && toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_TASK_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating task error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_TASK_FAILED,
      payload: error?.message
    })
  } finally {
    document.body.classList.remove('glass-overlay');
  }
}

export const deleteTask = (id) => async dispatch => {
  dispatch({
    type: DELETE_TASK
  })
  try {
    let response = await api(`task/delete/${id}`, 'delete', {}, getAuthHeader())
    console.log('deleted task data', response);
    toast.success("Deleted Successfully");
    dispatch({
      type: DELETE_TASK_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while deleting task error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: DELETE_TASK_FAILED,
      payload: error?.message
    })
  }
}

export const getTaskCategoryList = () => async (dispatch) => {
  dispatch({
    type: TASK_CATEGORY,
  });
  try {
    let response = await api(`task/taskCategory`, "get", {}, getAuthHeader());
    dispatch({
      type: TASK_CATEGORY_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Task Category list error ====>", error);
    return dispatch({
      type: TASK_CATEGORY_FAILED,
      payload: error?.message,
    });
  }
};

export const addTaskCategory = (data) => async dispatch => {
  dispatch({
    type: ADD_TASK_CATEGORY
  })
  try {
    let response = await api(`task/addTaskCategory`, 'post', data, getAuthHeader())
    console.log('add task category data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_TASK_CATEGORY_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding task category error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_TASK_CATEGORY_FAILED,
      payload: error?.message
    })
  }
}

export const deleteTaskCategory = (id) => async dispatch => {
  dispatch({
    type: DELETE_TASK_CATEGORY
  })
  try {
    let response = await api(`task/deleteTaskCategory/${id}`, 'delete', {}, getAuthHeader())
    console.log('deleted task category data', response);
    toast.success("Deleted Successfully");
    dispatch({
      type: DELETE_TASK_CATEGORY_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while deleting task category error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: DELETE_TASK_CATEGORY_FAILED,
      payload: error?.message
    })
  }
}

export const getTaskLabelList = () => async (dispatch) => {
  dispatch({
    type: TASK_LABEL,
  });
  try {
    let response = await api(`task/taskLabel`, "get", {}, getAuthHeader());
    dispatch({
      type: TASK_LABEL_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Task Label list error ====>", error);
    return dispatch({
      type: TASK_LABEL_FAILED,
      payload: error?.message,
    });
  }
};

export const addTaskLabel = (data) => async dispatch => {
  dispatch({
    type: ADD_TASK_LABEL
  })
  try {
    let response = await api(`task/addTaskLabel`, 'post', data, getAuthHeader())
    console.log('add task label data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_TASK_LABEL_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding Task Label error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_TASK_LABEL_FAILED,
      payload: error?.message
    })
  }
}

export const updateTaskLabel = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_TASK_LABEL
  })
  try {
    let response = await api(`task/updateTaskLabel/${id}`, 'put', data, getAuthHeader())
    console.log('update task label data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_TASK_LABEL_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating task label error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_TASK_LABEL_FAILED,
      payload: error?.message
    })
  }
}

export const deleteTaskLabel = (id) => async dispatch => {
  dispatch({
    type: DELETE_TASK_LABEL
  })
  try {
    let response = await api(`task/deleteTaskLabel/${id}`, 'delete', {}, getAuthHeader())
    console.log('deleted task label data', response);
    toast.success("Deleted Successfully");
    dispatch({
      type: DELETE_TASK_LABEL_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while deleting task label error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: DELETE_TASK_LABEL_FAILED,
      payload: error?.message
    })
  }
}

export const getTaskFiles = () => async (dispatch) => {
  dispatch({
    type: TASK_FILES,
  });
  try {
    let response = await api(`task/taskFiles`, "get", {}, getAuthHeader());
    dispatch({
      type: TASK_FILES_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Task Files list error ====>", error);
    return dispatch({
      type: TASK_FILES_FAILED,
      payload: error?.message,
    });
  }
};

export const addTaskFiles = (data) => async dispatch => {
  dispatch({
    type: ADD_TASK_FILES
  })
  try {
    let response = await api(`task/addTaskFiles`, 'post', data, getAuthHeader())
    console.log('add task files data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_TASK_FILES_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding task files error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_TASK_FILES_FAILED,
      payload: error?.message
    })
  }
}

export const updateTaskFiles = (id, data, showToast) => async dispatch => {
  dispatch({
    type: UPDATE_TASK_FILES
  })
  try {
    let response = await api(`task/updateTaskFiles/${id}`, 'put', data, getAuthHeader())
    console.log('update task files data', response);
    showToast && toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_TASK_FILES_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating task files error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_TASK_FILES_FAILED,
      payload: error?.message
    })
  }
}

export const deleteTaskFiles = (id) => async dispatch => {
  dispatch({
    type: DELETE_TASK_FILES
  })
  try {
    let response = await api(`task/deleteTaskFiles/${id}`, 'delete', {}, getAuthHeader())
    console.log('deleted task files data', response);
    toast.success("Deleted Successfully");
    dispatch({
      type: DELETE_TASK_FILES_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while deleting task files error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: DELETE_TASK_FILES_FAILED,
      payload: error?.message
    })
  }
}

export const getSubTaskList = () => async (dispatch) => {
  dispatch({
    type: SUB_TASK,
  });
  try {
    let response = await api(`task/subTask`, "get", {}, getAuthHeader());
    dispatch({
      type: SUB_TASK_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Sub Task list error ====>", error);
    return dispatch({
      type: SUB_TASK_FAILED,
      payload: error?.message,
    });
  }
};

export const addSubTask = (data) => async dispatch => {
  dispatch({
    type: ADD_SUB_TASK
  })
  try {
    let response = await api(`task/addSubTask`, 'post', data, getAuthHeader())
    console.log('add sub task data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_SUB_TASK_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding sub task error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_SUB_TASK_FAILED,
      payload: error?.message
    })
  }
}

export const updateSubTask = (id, data, showToast) => async dispatch => {
  dispatch({
    type: UPDATE_SUB_TASK
  })
  try {
    let response = await api(`task/updateSubTask/${id}`, 'put', data, getAuthHeader())
    console.log('update sub task data', response);
    showToast && toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_SUB_TASK_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating sub task error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_SUB_TASK_FAILED,
      payload: error?.message
    })
  }
}

export const deleteSubTask = (id) => async dispatch => {
  dispatch({
    type: DELETE_SUB_TASK
  })
  try {
    let response = await api(`task/deleteSubTask/${id}`, 'delete', {}, getAuthHeader())
    console.log('deleted sub task data', response);
    toast.success("Deleted Successfully");
    dispatch({
      type: DELETE_SUB_TASK_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while deleting sub task error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: DELETE_SUB_TASK_FAILED,
      payload: error?.message
    })
  }
}

export const getTaskStatus = () => async (dispatch) => {
  dispatch({
    type: TASK_STATUS,
  });
  try {
    let response = await api(`task/taskStatus`, "get", {}, getAuthHeader());
    dispatch({
      type: TASK_STATUS_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching task status error ====>", error);
    return dispatch({
      type: TASK_STATUS_FAILED,
      payload: error?.message,
    });
  }
};

export const addTaskStatus = (data) => async dispatch => {
  dispatch({
    type: ADD_TASK_STATUS
  })
  try {
    let response = await api(`task/addTaskStatus`, 'post', data, getAuthHeader())
    console.log('add task status data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_TASK_STATUS_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding task status error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_TASK_STATUS_FAILED,
      payload: error?.message
    })
  }
}

export const updateTaskStatus = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_TASK_STATUS
  })
  document.body.style.cursor = 'wait';
  try {
    let response = await api(`task/updateTaskStatus/${id}`, 'put', data, getAuthHeader())
    console.log('update task status data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_TASK_STATUS_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating task status error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_TASK_STATUS_FAILED,
      payload: error?.message
    })
  } finally {
    document.body.style.cursor = 'default';
  }
}

export const deleteTaskStatus = (id) => async dispatch => {
  dispatch({
    type: DELETE_TASK_STATUS
  })
  try {
    let response = await api(`task/deleteTaskStatus/${id}`, 'delete', {}, getAuthHeader())
    console.log('deleted task status data', response);
    toast.success("Deleted Successfully");
    dispatch({
      type: DELETE_TASK_STATUS_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while deleting task status error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: DELETE_TASK_STATUS_FAILED,
      payload: error?.message
    })
  }
}
export const getRunningTaskList = () => async (dispatch) => {
  dispatch({
    type: RUNNING_TASK,
  });
  try {
    let response = await api(`task/RunningTaskList`, "get", {}, getAuthHeader());
     dispatch({
      type: RUNNING_TASK_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Task list error ====>", error);
    return dispatch({
      type: RUNNING_TASK_FAILED,
      payload: error?.message,
    });
  }
};